// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WN7NxVYwDKQuDf {
  box-sizing: border-box;
  padding: var(--ds-space-025, 2px);
}
.CLtxrBpWkw5Uk2 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: var(--ds-space-025, 2px);
  overflow: hidden;
  border-radius: var(--ds-border-radius-100, 4px);
}
.CLtxrBpWkw5Uk2 .s0okHrzgTCe2yV {
  display: flex;
  visibility: hidden;
  flex: 0 0 auto;
  margin: var(--ds-space-050, 4px);
  gap: var(--ds-space-050, 4px);
}
.CLtxrBpWkw5Uk2 .s0okHrzgTCe2yV button {
  padding: var(--ds-space-050, 4px);
}
.CLtxrBpWkw5Uk2:hover,
.CLtxrBpWkw5Uk2:focus-within {
  background: var(--ds-background-neutral-hovered, #091e4224);
}
.CLtxrBpWkw5Uk2:hover .s0okHrzgTCe2yV,
.CLtxrBpWkw5Uk2:focus-within .s0okHrzgTCe2yV {
  visibility: visible;
}
.CLtxrBpWkw5Uk2:focus-within,
.CLtxrBpWkw5Uk2.IvqY8CiOp8z2aS {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .CLtxrBpWkw5Uk2:focus-within,
.mac .CLtxrBpWkw5Uk2.IvqY8CiOp8z2aS {
  outline-color: -webkit-focus-ring-color;
}
.CLtxrBpWkw5Uk2:focus-within .mac.firefox,
.CLtxrBpWkw5Uk2.IvqY8CiOp8z2aS .mac.firefox {
  outline-color: AccentColor;
}
.F4YQ4jd_7bxa4L {
  flex: 1 1;
  justify-content: flex-start;
  min-width: 0;
  height: 40px;
  padding: var(--ds-space-075, 6px);
  font-size: 14px;
  font-weight: var(--ds-font-weight-bold, 700);
  text-align: left;
  cursor: pointer;
}
.F4YQ4jd_7bxa4L .sTejVsN1OchX5W {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.F4YQ4jd_7bxa4L .sTejVsN1OchX5W svg {
  width: 16px;
  height: 16px;
  margin-right: var(--ds-space-050, 4px);
}
.F4YQ4jd_7bxa4L:hover {
  background: none;
}
.F4YQ4jd_7bxa4L:focus {
  outline: none;
}
.mAyETevc15vDZb {
  transform: rotate(-90deg);
  transition: transform 0.1s;
}
.mAyETevc15vDZb.isyUtZ7bm5k9Cj {
  transform: rotate(0deg);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"expandSection": `WN7NxVYwDKQuDf`,
	"heading": `CLtxrBpWkw5Uk2`,
	"actions": `s0okHrzgTCe2yV`,
	"active": `IvqY8CiOp8z2aS`,
	"button": `F4YQ4jd_7bxa4L`,
	"title": `sTejVsN1OchX5W`,
	"icon": `mAyETevc15vDZb`,
	"expanded": `isyUtZ7bm5k9Cj`
};
export default ___CSS_LOADER_EXPORT___;
